import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 9 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.017 8a.98.98 0 0 1-.287.695l-6.035 6.034a.983.983 0 1 1-1.39-1.39L5.645 8 .305 2.66a.983.983 0 0 1 1.39-1.39L7.73 7.306A.98.98 0 0 1 8.017 8" }, null, -1)
  ]))]))
}
export default { render: render }